module.exports = __webpack_public_path__ + "img/ic24Warning.ea6f4707.svg";